module.exports = __webpack_public_path__ + "static/media/buy_interview_5.dfe881a3.jpg";